<script setup lang="ts">
import { defineAsyncComponent, Prop } from 'vue'
// Stores
import { useBasketStore } from '~/store/basket/basket'
/* Components */
import BasketTitle from '~/components/Basket/basket-utils/BasketTitle.vue'
import BasketAdditiveList from '~/components/Basket/basket-additive/BasketAdditiveList.vue'
/* Types */
import { Additive } from '~/types/api/api-v3/basket'

const DialogBasketAskAdditives = defineAsyncComponent(
  () => import('@/components/Basket/dialogs/DialogBasketAskAdditives.vue'),
)
const DialogBasketAskAdditivesTitle = defineAsyncComponent(
  () =>
    import(
      '@/components/Basket/basket-additive/DialogBasketAskAdditivesTitle.vue'
    ),
)

const emit = defineEmits([
  'orderCheckout',
  'orderCheckoutForPay',
  'scrollToField',
])
defineProps({
  additives: {
    type: Array,
    required: true,
  } as Prop<Additive[]>,
})

const basketStore = useBasketStore()

const isAdditiveDialogVisible = ref(false)

const clientPacksCount = computed(() => basketStore.clientPacksCount)
const clientAdditivesCount = computed(() => basketStore.clientAdditivesCount)

const agreeAdditivesTitle = computed(() => {
  if (!clientPacksCount.value && !clientAdditivesCount.value) {
    return 'Вы заказываете без приборов и соусов, все верно?'
  }

  if (!clientPacksCount.value) {
    return 'Количество приборов в заказе - 0. Вы уверены, что хотите сделать заказ без приборов?'
  }

  return 'Вы заказываете без соусов, все верно?'
})

const arrangeWithoutAdditives = () => {
  isAdditiveDialogVisible.value = false

  emit('orderCheckout')
}

const payWithoutAdditives = () => {
  isAdditiveDialogVisible.value = false

  emit('orderCheckoutForPay')
}

const backToSelection = () => {
  isAdditiveDialogVisible.value = false

  if (!clientPacksCount.value) {
    emit('scrollToField', 'clientPack')

    return
  }

  if (!clientAdditivesCount.value) scrollToBlock('#additives')
}
</script>

<template>
  <section id="additives">
    <basket-title title="Не забудьте добавки и соусы" />

    <basket-additive-list :additives="additives" />

    <app-dialog
      v-if="isAdditiveDialogVisible"
      v-model="isAdditiveDialogVisible"
      :max-width="'360'"
    >
      <template #title>
        <dialog-basket-ask-additives-title
          :agree-additives-title="agreeAdditivesTitle"
        />
      </template>

      <template #body>
        <dialog-basket-ask-additives
          @arrange-without-additives="arrangeWithoutAdditives"
          @back-to-selection="backToSelection"
          @pay-without-additives="payWithoutAdditives"
        />
      </template>
    </app-dialog>
  </section>
</template>
